import React, { Children } from 'react';
import PropTypes from 'prop-types';
import SplitPane from 'react-split-pane';
import _compact from 'lodash/compact';

import { loadState, saveState } from 'store/utils/localStorage';

import './style.scss';

export const DEFAULT_MIN_SIZE = {
  vertical: 350,
  horizontal: 150,
};

export const DEFAULT_VALUES = {
  vertical: '33%',
  horizontal: '50%',
};

export const SPLITTER_POSITION = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

export const SPLITTER_KEY_NAME_ON_LOCALSTORAGE = 'nlu:splitter';

const getLocalStorageKeyName = split =>
  `${SPLITTER_KEY_NAME_ON_LOCALSTORAGE}:${split}`;

// Recovers latest size from localStorage
export const getLastSize = split => {
  const localStorageKeyName = getLocalStorageKeyName(split);
  const size = loadState(localStorageKeyName);

  if (size) {
    return parseInt(size, 10);
  }

  return DEFAULT_VALUES[split];
};

const handleResize = (size, split) => {
  // Save to localStorage at different variables vertical and horizontal splitter values
  // so they do not conflict each other
  const localStorageKeyName = getLocalStorageKeyName(split);
  saveState(size, localStorageKeyName);
};

// Todo: use custom hook for localStorage logic
const Splitter = ({ split, children, minSize, maxSize, onChange }) => {
  const defaultMinSize = DEFAULT_MIN_SIZE[split];

  // Do not split window for one pane only
  const childrenArr = _compact(Children.toArray(children));

  if (childrenArr.length <= 1) {
    return childrenArr[0] || null;
  }

  return (
    <SplitPane
      defaultSize={getLastSize(split)}
      maxSize={maxSize || -defaultMinSize}
      minSize={minSize || defaultMinSize}
      split={split}
      styleName="splitter"
      onChange={size => {
        handleResize(size, split);
        if (typeof onChange === 'function') {
          onChange(size);
        }
      }}
    >
      {children}
    </SplitPane>
  );
};

Splitter.propTypes = {
  children: PropTypes.node,
  maxSize: PropTypes.string,
  minSize: PropTypes.string,
  split: PropTypes.oneOf(Object.values(SPLITTER_POSITION)),
  onChange: PropTypes.func,
};

Splitter.defaultProps = {
  split: SPLITTER_POSITION.VERTICAL,
};

export default Splitter;
